import React from 'react';
import { Box } from '@chakra-ui/react';
import { useLocation } from 'react-router-dom';
import { useTabBarVisibility } from '../contexts/TabBarVisibilityContext';
import { walletColors } from '../features/wallet/walletTheme';
import TabBar from './TabBar';
import { navClearance } from '../theme';
import { WhopPayoutsModalProvider } from '../features/wallet/contexts/WhopPayoutsModalContext';

interface MainLayoutProps {
  children: React.ReactNode;
}

const MainLayout: React.FC<MainLayoutProps> = ({ children }) => {
  const location = useLocation();
  const { hideTabBar } = useTabBarVisibility();
  const showTabBarBase =
    ['/collabs', '/wallet', '/explore', '/inbox'].includes(location.pathname) ||
    location.pathname.startsWith('/profile') ||
    location.pathname.startsWith('/bounties');
  const showTabBar = showTabBarBase && !hideTabBar;
  const isWalletRoute = location.pathname === '/wallet';

  return (
    <WhopPayoutsModalProvider>
      <Box minH="100vh" bg={isWalletRoute ? walletColors.pageBg : 'white'} position="relative">
        <Box pb={showTabBar ? navClearance : "0"}>
          {children}
        </Box>
        {showTabBar && <TabBar />}
      </Box>
    </WhopPayoutsModalProvider>
  );
};

export default MainLayout;
